// Base class for the seed guarentees keys and timestamps

class DataTableBase {
  constructor (pk, sk) {
    this.identifier = {
      pk,
      sk,
    };
  }
}

class MapTableBase {
  constructor (pk, sk, gsipk, gsisk) {
    this.identifier = {
      pk,
      sk,
      gsipk,
      gsisk,
    };
  }
}

class WebsocketTableBase {
  constructor (pk, sk, gsipk, gsisk) {
    this.identifier = {
      pk,
      sk,
      gsipk,
      gsisk,
    };
  }
}

class MessageTableBase {
  constructor (pk, sk) {
    this.identifier = {
      pk,
      sk,
    };
  }
}

class WebRtcTableBase {
  constructor (pk, sk, gsipk, gsisk) {
    this.identifier = {
      pk,
      sk,
      gsipk,
      gsisk,
    };
  }
}

class ConferenceRoomTableBase {
  constructor (pk, sk) {
    this.identifier = {
      pk,
      sk,
    };
  }
}

class NotificationTableBase {
  constructor (pk, sk) {
    this.identifier = {
      pk,
      sk,
    };
  }
}

class AuthTableBase {
  constructor (pk, sk, gsipk, gsisk) {
    this.identifier = {
      pk,
      sk,
      gsipk,
      gsisk,
    };
  }
}

exports.DataTableBase = DataTableBase;
exports.MapTableBase = MapTableBase;
exports.WebsocketTableBase = WebsocketTableBase;
exports.MessageTableBase = MessageTableBase;
exports.WebRtcTableBase = WebRtcTableBase;
exports.ConferenceRoomTableBase = ConferenceRoomTableBase;
exports.NotificationTableBase = NotificationTableBase;
exports.AuthTableBase = AuthTableBase;